import { put, call, takeEvery, all } from 'redux-saga/effects'

import { GQL } from '../services'
import history from '../history'
import {
  REACTIVATE_SUBSCRIPTION_INIT,
  REACTIVATE_SUBSCRIPTION_SUCCESS,
  REACTIVATE_SUBSCRIPTION_FAILURE
} from '../actions/types'
import { toaster } from '../../utils/toaster'

export function* reactivateSubscription({ payload }) {
  try {
    const subscriptionData = yield call(GQL.reactivateSubscription)

    let prepaidResponse = {}
    let redirectToDeliveryDate
    let redirectChefId

    const resurrectionCampaign = {
      id: payload?.resurrectionCampaign?.id,
      chefId: payload?.resurrectionCampaign?.chefId,
      chefBrandId: payload?.resurrectionCampaign?.chefBrandId,
      highlightedMealsIds:
        payload?.resurrectionCampaign?.highlightedMealsIds || [],
      couponCode: payload?.resurrectionCampaign?.couponCode,
      prepaidCampaign: payload?.resurrectionCampaign?.prepaidCampaign,
      chefBrandIds: payload?.resurrectionCampaign?.chefBrandIds
    }

    const couponCode = resurrectionCampaign?.couponCode || payload?.coupon
    const prepaidOffer =
      resurrectionCampaign?.prepaidCampaign || payload?.prepaidOfferId

    if (couponCode) {
      try {
        yield call(GQL.consumeCoupon, couponCode, true)
      } catch (error) {
        console.error(error)
      }
    }

    if (prepaidOffer) {
      prepaidResponse = yield call(GQL.assignPrepaidOffer, prepaidOffer)
      if (prepaidResponse?.assignPrepaidOffer?.status) {
        toaster.success(
          <span>
            Your prepaid offer was successfully applied to your subscription.
          </span>,
          { autoClose: 5000 }
        )
      } else {
        toaster.error(
          <span>
            There was an error with your prepaid offer. Please contact support.
          </span>,
          { autoClose: 5000 }
        )
      }
    }

    if (resurrectionCampaign.id) {
      try {
        const chefCartResponse = yield call(
          GQL.generateCartFromResurrectionCampaign,
          {
            campaignSlug: resurrectionCampaign.id,
            chefId: resurrectionCampaign.chefId,
            chefBrandId: resurrectionCampaign.chefBrandId,
            chefBrandIds: resurrectionCampaign.chefBrandIds,
            highlightedMealsIds: resurrectionCampaign.highlightedMealsIds
          }
        )
        redirectToDeliveryDate =
          chefCartResponse?.generateCartFromResurrectionCampaign?.deliveryDate

        redirectChefId =
          chefCartResponse?.generateCartFromResurrectionCampaign?.chefId
      } catch (error) {
        console.error(error)
      }
    }

    toaster.success(
      <span>
        Your subscription was successfully <b>reactivated</b>. See what's new
        and order your next delivery!
      </span>,
      { autoClose: 5000 }
    )

    yield put({
      type: REACTIVATE_SUBSCRIPTION_SUCCESS,
      payload: subscriptionData
    })

    // TODO Find a way to reload subscription data using redux from this saga or remove sagas.
    setTimeout(() => {
      if (redirectToDeliveryDate) {
        history.push(
          `/meals?date=${redirectToDeliveryDate}${
            redirectChefId ? `&chef=${redirectChefId}` : ''
          }`
        )
      } else {
        history.push('/validate-cc')
      }
      window.location.reload()
      // Enough time to read the toast message
    }, 5000)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error)
    yield put({
      type: REACTIVATE_SUBSCRIPTION_FAILURE,
      error
    })
  }
}

export default function* rootInitialSaga() {
  yield all([takeEvery(REACTIVATE_SUBSCRIPTION_INIT, reactivateSubscription)])
}
